import { DEFAULT_COUNTRY_CODE } from '@/lib/constants/countries';
import { normalizeStateCode } from '@/lib/functions/normalizeStateCode';
import { normalizeZipCode } from '@/lib/functions/normalizeZipCode';
import { processShippingMethodsForLocation } from '@/lib/functions/processShippingMethods';

import type { ProcessedShippingEligibility } from '@/lib/types/shippingEligibilityState';
import type { ShippingMethodsResponse } from '@/lib/types/shipping';

export async function fetchShippingRulesForLocation(
  provinceCode: string | null,
  postalCode: string | null,
  countryCode: string | null = DEFAULT_COUNTRY_CODE,
): Promise<ProcessedShippingEligibility> {
  const state = normalizeStateCode(provinceCode);
  const zipCode = normalizeZipCode(postalCode);
  const channelCode = process.env.NEXT_PUBLIC_SYLIUS_CHANNEL_CODE ?? 'PARTYSUPPLIES';

  const response = await fetch(`/api/shipping-methods/rules?channelCode=${encodeURIComponent(channelCode)}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch shipping rules: ${response.status} ${response.statusText}`);
  }

  const data: ShippingMethodsResponse = await response.json();
  return processShippingMethodsForLocation(data.shippingMethods || [], state, zipCode, countryCode);
}
